import ScrollView from "devextreme-react/scroll-view";
import { useCallback, useState } from "react";
import { Button } from "../../../components/buttons";
import { DefaultPopup } from "../../../components/modal";
import { sf_tbtp_viewmodel } from "../../../models/response/tbtp/sf_tbtp";
import TbtpEditLayoutTab from "./TbtpEditTab/TbtpEditLayoutTab";
import { tbtpApi } from "../../../api/tbtpApi";

type TBTPEditModalProps = {
    sf_tbtp: sf_tbtp_viewmodel,
    onCancel: () => void,
    isReadOnly?: boolean
}

export const TBTPEditModal = (props: TBTPEditModalProps) => {
    const [isLoading, setIsLoading] = useState(false)
    const onClose = useCallback(() => {
        window.animationHidePopup("")
        setTimeout(() => {
            props.onCancel();
        }, 500);
    }, [])
    const onReUpdate = async () => {
        setIsLoading(true)
        const res = await tbtpApi.reupdate_tbtp(props.sf_tbtp.id)
        props.onCancel();
        setIsLoading(false)
    }
    return (
        <DefaultPopup
            maxWidth={window.innerWidth - 200}
            title="Khoản nộp TBTP"
            onClose={onClose}
        >
            <ScrollView width={window.innerWidth - 200} height={window.innerHeight - 200}>
                <div className="pop-up-form">
                    <TbtpEditLayoutTab
                        sf_tbtp={props.sf_tbtp}
                        isReadOnly={props.isReadOnly}
                        onCancel={onClose}
                    />
                </div>
            </ScrollView>
            <div className="pop-up-actions">
                <Button icon="fas fa-times" onClick={() => { props.onCancel() }} text="Đóng" isLoading={isLoading}></Button> {" "}

                <Button icon="fas fa-check-square" onClick={() => { onReUpdate() }} text="Cập nhật" isLoading={isLoading}></Button> {" "}
            </div>
        </DefaultPopup >
    );
}